export default class Notification
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Notification.prototype.defaults, ...options }
        this.init()
    }

    init() {
        document.body.addEventListener('notification:show', this.onShow.bind(this))
        //setTimeout(function(){ document.body.dispatchEvent(new CustomEvent('notification:show', { detail: {'message' : "test notification"} })) }, 1000);
    }

    onShow(data) {
        if(this.DOM.notification){
            this.DOM.notification.remove()
        }
        let style = data.detail.type && this.options.availableStyles.includes(data.detail.type) ? data.detail.type : 'success'

        this.DOM.notification = document.createElement('div')
        this.DOM.notification.classList.add(this.options.selectorNotification, this.options.selectorNotification + '--' + style)
        this.DOM.$el.appendChild(this.DOM.notification)
        this.DOM.notification.classList.add(this.options.classNameShow)

        if(data.detail.title){
            let heading = document.createElement('h4')
            heading.innerHTML = data.detail.title
            this.DOM.notification.appendChild(heading);
            heading.classList.add(this.options.selectorNotification + '__heading')
        }

        let message = document.createElement('p')
        this.DOM.notification.appendChild(message);
        message.innerHTML = data.detail.message
        message.classList.add(this.options.selectorNotification + '__text')

        let button = document.createElement('button')
        this.DOM.notification.appendChild(button);
        button.classList.add(this.options.selectorNotification + '__hide')



        button.addEventListener('click', this.onHideClick.bind(this), { once: false, passive: true })
        setTimeout(this.hide.bind(null, [this.DOM.notification, this.options.classNameShow]), 5400);
    }

    hide(args){
        let notification = args[0]
        let classShow = args[1]
        if(notification){
            notification.style.height = `${notification.getBoundingClientRect().height}px`
            notification.classList.remove(classShow)
            notification.remove()
        }
    }

    onHideClick() {
        this.DOM.notification.style.height = `${this.DOM.notification.getBoundingClientRect().height}px`
        this.DOM.notification.classList.remove(this.options.classNameShow)
        this.DOM.notification.remove()
    }

}

Notification.prototype.defaults = {
    selectorNotification: 'c-notification',
    classNameShow: 'show',
    availableStyles: ['success', 'neutral', 'alert'],
}